import { useCallback, useEffect, useState } from 'react';

const SAVED_JOBS_KEY = 'heytraveler.saved-care-team-jobs';
const STARTED_APPLICATIONS_KEY = 'heytraveler.started-care-team-applications';

const readIds = (key) => {
  try {
    const value = JSON.parse(window.localStorage.getItem(key) || '[]');
    return new Set(Array.isArray(value) ? value.map(String) : []);
  } catch {
    return new Set();
  }
};

const writeIds = (key, ids) => {
  try {
    window.localStorage.setItem(key, JSON.stringify([...ids]));
  } catch {
    // Browser privacy settings may block local storage. The core apply flow still works.
  }
};

export const useJobInteractions = () => {
  const [savedJobIds, setSavedJobIds] = useState(() => readIds(SAVED_JOBS_KEY));
  const [startedApplicationIds, setStartedApplicationIds] = useState(
    () => readIds(STARTED_APPLICATIONS_KEY),
  );

  useEffect(() => {
    const syncAcrossTabs = (event) => {
      if (event.key === SAVED_JOBS_KEY) setSavedJobIds(readIds(SAVED_JOBS_KEY));
      if (event.key === STARTED_APPLICATIONS_KEY) {
        setStartedApplicationIds(readIds(STARTED_APPLICATIONS_KEY));
      }
    };
    window.addEventListener('storage', syncAcrossTabs);
    return () => window.removeEventListener('storage', syncAcrossTabs);
  }, []);

  const toggleSavedJob = useCallback((jobId) => {
    const normalizedId = String(jobId);
    setSavedJobIds((current) => {
      const next = new Set(current);
      if (next.has(normalizedId)) next.delete(normalizedId);
      else next.add(normalizedId);
      writeIds(SAVED_JOBS_KEY, next);
      return next;
    });
  }, []);

  const markApplicationStarted = useCallback((jobId) => {
    const normalizedId = String(jobId);
    setStartedApplicationIds((current) => {
      const next = new Set(current);
      next.add(normalizedId);
      writeIds(STARTED_APPLICATIONS_KEY, next);
      return next;
    });
  }, []);

  return {
    savedJobIds,
    startedApplicationIds,
    toggleSavedJob,
    markApplicationStarted,
  };
};
